import { TrainerWorkoutList } from '../../component/trainer/trainer-workout-list'
import React from 'react'
import { useParams } from 'react-router-dom'
import { PageContainer } from 'src/component/page-container/page-container'

export const TrainerWorkoutsScreen = (): React.ReactElement => {
  const { trainerId } = useParams<{ trainerId: string }>()

  if (!trainerId) {
    return <div>Trainer not found</div>
  }

  return (
    <PageContainer>
      <TrainerWorkoutList trainerId={trainerId} />
    </PageContainer>
  )
}
